import React from 'react';
import { observer } from 'mobx-react-lite';
import { PRODUCT_TEMPLATE_STATUS_TITLES, ProductTemplateExtendedStatus } from 'types/productServiceV2';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { PRODUCT_TEMPLATES_FILTERS } from '../../constants';

export const StatusFilterDropdown: React.FC = observer(() => {
  const {
    paginationDelegate: { filters, setFilterValue },
  } = useRFQProductTemplatesStore();

  const statusOptions = Object.entries(PRODUCT_TEMPLATE_STATUS_TITLES).map(([value, label]) => ({
    value,
    label,
  }));

  const onApplyFilter = (value: string | null): void => {
    if (value) {
      setFilterValue('status', value as ProductTemplateExtendedStatus);
    }
  };

  return (
    <FilterDropdown
      filterName="Status"
      $minWidth="25rem"
      optionsWidth="25rem"
      selectedFilterLabel={PRODUCT_TEMPLATE_STATUS_TITLES[filters.status]}
      filtersList={statusOptions}
      applyFilter={onApplyFilter}
      data-test-id={PRODUCT_TEMPLATES_FILTERS.STATUS_FILTER_DROPDOWN_TEST_ID}
    />
  );
});
